const getTomorrow = () => { 
    var today = new Date();
    var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
    return tomorrow
}

export default getTomorrow